// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__5ZJ1Q","divider":"breadcrumbs_divider__CAPY5"};